import { FC } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

export interface PdfFileData {
  id: number;
  fullPath: string;
  fileName: string;
  uploadedBy: string;
  createdAt: string;
}

interface PdfFileCardProps {
  file: PdfFileData;
  isImg: boolean
}

const PdfFileCard: FC<PdfFileCardProps> = ({ file, isImg }) => {


  const { t } = useTranslation()

  return (
    <div className="pdf-card">
      <div className={`pdf-preview  ${isImg ? "for-img" : ""} `}>
        <img src={isImg ? `${window.API_URL}/${file.fullPath}` : "https://cdn-icons-png.flaticon.com/512/337/337946.png"}
          alt="PDF Icon" />
        {isImg ? "" : <span className="pdf-badge">PDF</span>}
      </div>

      <div className="pdf-content">
        <h4 className="pdf-name">{file.fileName}</h4>

        <p className="pdf-info uploader">
          <i className="icon">👤</i> {file.uploadedBy}
        </p>

        <p className="pdf-info date">
          <i className="icon">📅</i> {file.createdAt}
        </p>

        <a
          href={`${window.API_URL}/${file.fullPath}`}
          target="_blank"
          rel="noopener noreferrer"
          className="pdf-btn"
        >
          👁️ {isImg ? t("show-img") : t("show-pdf")}
        </a>
      </div>
    </div>
  );
};

export default PdfFileCard;
